import React, { Component } from 'react'
import Modal from 'react-modal'
import classNames from 'classnames'

import './css/secur-space-modal.css'

interface SecurSpaceModalProps {
  isOpen: boolean;
  className?: string;
  overlayClassName?: string;
  children?: React.ReactNode;
  onRequestClose?: () => void;
  contentLabel?: string;
}

export default class SecurSpaceModal extends Component<SecurSpaceModalProps> {
  constructor(props: SecurSpaceModalProps) {
    super(props);

    Modal.setAppElement('#root')
  }

  render() {
    const { isOpen, className, overlayClassName, onRequestClose, contentLabel } = this.props
    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        contentLabel={contentLabel}
        className={classNames("secur-space-modal", className)}
        overlayClassName={classNames("secur-space-modal-overlay", overlayClassName)}
      >
        {this.props.children}
      </Modal>
    )
  }
}
